// Traveler Types
export const ADULTS = "adults";
export const CHILDREN = "children";
export const LAP_CHILDREN = "lapChildren";

// Defaults
export const DEFAULT_ADULTS = 2;
export const DEFAULT_CHILD_AGE = 2;

// Maximums
export const MAXIMUM_ADULTS_PER_ROOM = 4;
export const MAXIMUM_TRAVELERS_PER_ROOM = 6;
export const ROOM_MAX_COUNT = 4;
export const TRAVELERS_MAX_COUNT = 8;

// Minimums
export const MINIMUM_ADULTS = 1;
export const ROOM_MIN_COUNT = 1;
